
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mui-x-v6-alpha-zero",
      function () {
        return require("private-next-pages/blog/mui-x-v6-alpha-zero.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/mui-x-v6-alpha-zero"])
      });
    }
  